<template>
<div class="pricingDetailsBlock">
  <h4>{{ $t($i18n.locale + '.keys.premiumPlans.processPayments.pricingDetails_headline') }}</h4>
    <p>
      <span v-if="domain != 'cz'">{{ this.infoTextDuration }},&nbsp;</span>
      <span v-else >{{ $t($i18n.locale + '.keys.premiumPlans.processPayments.pricingDetails_sum') }}&nbsp;</span>
      <span>
        <template v-if="selectedLanguage == 'en'">
          {{ this.getActivePlan.plansPrice.currencySign }}{{ this.getActivePlan.plansPrice.visiblePrice }}.{{ this.getActivePlan.plansPrice.visiblePriceCents }}/{{ this.getActivePlan.plansPrice.perMonth }},
        </template>
        <template v-else>
          {{ this.getActivePlan.plansPrice.visiblePrice }},{{ this.getActivePlan.plansPrice.visiblePriceCents }}{{ this.getActivePlan.plansPrice.currencySign }}/{{ this.getActivePlan.plansPrice.perMonth }},
        </template>
      </span>

    </p>
    <p>
      <span v-if="domain == 'cz'">{{ this.infoTextDuration }},&nbsp;</span>
      <span v-else >{{ $t($i18n.locale + '.keys.premiumPlans.processPayments.pricingDetails_sum') }}&nbsp;</span>
      <template v-if="selectedLanguage == 'en'">
        <span v-if="this.getActivePlan.plansPrice.discount && this.getActivePlan.plansPrice.initialPrice">
          {{ this.getActivePlan.plansPrice.currencySign + this.getActivePlan.plansPrice.initialFullPrice }}
        </span>
        <span v-else>{{ this.getActivePlan.plansPrice.currencySign + this.getActivePlan.plansPrice.fullPrice}}</span>
      </template>
      <template v-else>
        <span v-if="this.getActivePlan.plansPrice.discount && this.getActivePlan.plansPrice.initialPrice">
          {{ this.getActivePlan.plansPrice.initialFullPrice.replace('.', ',') + this.getActivePlan.plansPrice.currencySign }}
        </span>
        <span v-else>{{ this.getActivePlan.plansPrice.fullPrice.replace('.', ',') + this.getActivePlan.plansPrice.currencySign }}</span>
      </template>

    </p>
</div>
</template>

<script>
export default {
  name: 'PricingDetails',
  props: {
    selectedLanguage: {
      type: String,
      required: true
    },
    domain: {
      type: String,
      required: false,
      default: window.domain
    },
    getActivePlan: {
      type: Object,
      required: true
    }
  },
  computed: {
    infoTextDuration: function(){
      return this.getActivePlan.plansInfoBody.headlinePeriod
    },
  }
}
</script>
<style lang="scss" scoped>

.pricingDetailsBlock {
  position:absolute;
  left: 0;
  width: 100%;
  padding: 3px 5px;
  background-color: var(--accent01-500);
  color: var(--accent01-200);
  font-size: 0.8em;
  line-height: 1.2;
  h4 {
    font-size: 1em;
    //font-weight: 600;
    margin: 0;
  }
  p {
    margin: 0;
  }
}

</style>